import React from 'react';
import { Box, Button, CircularProgress, Stack } from '@mui/material';
import { CssTextField } from '../../components/TextField';
import { updateAgent } from '../../store/actions';
import { Formik } from 'formik';
import Header from '../../components/Header';
import * as yup from "yup";

function UpdateAgentModalContent({ dispatch, isLoading, setModal, colors, updateAgentData }) {

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { sm: 400, xs: "90%" },
        bgcolor: colors.primary[400],
        outline: "none",
        boxShadow: 24,
        p: 2,
    };

    const initialValues = {
        id: updateAgentData?._id,
        firstName: updateAgentData?.first_name ?? "",
        email: updateAgentData?.email ?? "",
        mobile: updateAgentData?.mobile ?? "",
        address: updateAgentData?.address ?? "",
        gst_number: updateAgentData?.gst_number ?? "",
    };

    const schema = yup.object().shape({
        firstName: yup.string().required("Name is required"),
        email: yup.string().email("Invalid email").required("Email is required"),
        mobile: yup.string(),
        address: yup.string(),
        gst_number: yup.string(),
    });

    const handleFormSubmit = async (values) => {
        await dispatch(updateAgent(values));
        setModal(false);
    };

    return (
        <Box sx={modalStyle}>
            <Header title="UPDATE AGENT" titleVariant="h4" />

            <Formik
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={schema}
            >
                {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Stack spacing={2}>

                            {/* Name */}
                            <CssTextField
                                required
                                fullWidth
                                size="small"
                                type="text"
                                label="Name"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.firstName}
                                name="firstName"
                                error={!!touched.firstName && !!errors.firstName}
                                helperText={touched.firstName && errors.firstName}
                            />

                            {/* Email */}
                            <CssTextField
                                required
                                fullWidth
                                size="small"
                                type="email"
                                label="Email"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.email}
                                name="email"
                                error={!!touched.email && !!errors.email}
                                helperText={touched.email && errors.email}
                            />

                            {/* Mobile */}
                            <CssTextField
                                fullWidth
                                size="small"
                                type="number"
                                label="Mobile"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.mobile}
                                name="mobile"
                                error={!!touched.mobile && !!errors.mobile}
                                helperText={touched.mobile && errors.mobile}
                            />

                            {/* Address */}
                            <CssTextField
                                required
                                fullWidth
                                size="small"
                                type="text"
                                label="Address"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.address}
                                name="address"
                                error={!!touched.address && !!errors.address}
                                helperText={touched.address && errors.address}
                            />

                            {/* GST Number */}
                            <CssTextField
                                fullWidth
                                size="small"
                                type="text"
                                label="GST Number"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.gst_number}
                                name="gst_number"
                                error={!!touched.gst_number && !!errors.gst_number}
                                helperText={touched.gst_number && errors.gst_number}
                            />

                            {/* Submit */}
                            <Button
                                fullWidth
                                size="large"
                                type="submit"
                                color="secondary"
                                variant="contained"
                                sx={{ fontSize: "15px" }}
                            >
                                {isLoading
                                    ? <CircularProgress color="inherit" size={24} />
                                    : <b>Submit</b>
                                }
                            </Button>

                        </Stack>
                    </form>
                )}
            </Formik>
        </Box>
    );
}

export default UpdateAgentModalContent;
